import sensors from '@/js_sdk/Sensorsdata/Sensorsdata-UniPlugin-JS/Sensorsdata-UniPlugin-JS/index.js';
import { IS_DEV, IS_APP, PROD_URLS, TEST_REPORT_URL, PROD_REPORT_URL, PAGES } from './const';
import Utils from '@/utils/utils';

// 获上报地址
function getReportUrl() {
  let url = TEST_REPORT_URL;
  if (IS_APP) {
    url = PROD_REPORT_URL;
  } else {
    const host = location.host;
    if (PROD_URLS.includes(host)) {
      url = PROD_REPORT_URL;
    }
  }
  return url;
}

function getNavigationBarTitle(url) {
  const route = url.split('?')[0].replace(/^\/+/, '');
  // 从 pages 文件中找到匹配的路径
  const page = PAGES.find((page) => page.path === route);
  return Utils.get(page, 'style.navigationBarTitleText', '');
}
function getCurrentRoute() {
  const pages = getCurrentPages();
  const currentPage = pages[pages.length - 1];
  return currentPage ? currentPage.route : '';
}

export default {
  ...sensors,
  init() {
    sensors.init({
      server_url: getReportUrl(),
      name: 'sensors',
      is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
      use_client_time: true,
      show_log: IS_DEV,
      send_type: 'beacon',
      heatmap: {
        //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'default',
        collect_tags: {
          'uni-view': true,
          span: true,
        },
      },
      app: {
        // Android & iOS 初始化配置
        remote_config_url: '',
        flush_interval: 15000, //两次数据发送的最小时间间隔，单位毫秒
        flush_bulkSize: 100, //设置本地缓存日志的最大条目数，最小 50 条， 默认 100 条
        flush_network_policy: 30, //设置 flush 时网络发送策略
        auto_track: 3, // 1 应用启动， 2 应用退出，3 应用启动和退出 默认 0
        encrypt: false, //是否开启加密
        add_channel_callback_event: false, //是否开启渠道事件
        javascript_bridge: true, // WebView 打通功能
        track_crash: false, // 是否采集 AppCrash
        android: {
          //Android 特有配置
          session_interval_time: 30000,
          request_network: true,
          max_cache_size: 32, // 默认 32MB，最小 16MB
          mp_process_flush: false, //使用小程序 SDK 时，小程序进程是否可发送数据
        },
        ios: {
          //iOS 特有配置
          max_cache_size: 10000, //最大缓存条数，默认 10000 条
        },
      },
    });

    sensors.quick('autoTrack'); //用于采集 $pageview 事件。

  },
  update_profile(data) {
    sensors.setProfile(data);
    sensors.register(data);
  },
  login(userInfo) {
    const data = {
      MemberId: userInfo.MemberId || '',
      Token: userInfo.Token || '',
      MemberName: userInfo.MemberName || '',
      EnterpriseId: userInfo.EnterpriseId || 0,
      CompanyName: userInfo.EnterpriseName || '',
      Version: userInfo.Version || '',
      PlatId: userInfo.PlatId || '',
    };
    sensors.login(userInfo.MemberId);
    this.update_profile(data);
  },
  track(eventName, eventDesc) {
    const route = getCurrentRoute();
    sensors.track(eventName, {
      name: eventDesc,
      $title: getNavigationBarTitle(route),
      $url_path: route,
    });
  },
  clickTrack(eventName, eventDesc) {
    this.track(eventName, eventDesc);
  },
  focusTrack(eventName, eventDesc) {
    this.track(eventName, eventDesc);
  },
  requestTrackCurry(eventDesc, requestModule = {}, request = {}) {
    const startTime = Date.now();
    return function (response = {}) {
      const endTime = Date.now();
      const duration = endTime - startTime;
      const route = getCurrentRoute();
      sensors.track('request', {
        name: eventDesc,
        duration: duration,
        request: {
          url: `${requestModule.module}/${requestModule.address}`,
          ...request,
        },
        response: response,
        $title: getNavigationBarTitle(route),
        $url_path: route,
      });
    };
  },
  pageviewTrack(data = {}) {
    const route = getCurrentRoute();
    if (route) {
      sensors.track('pageview', {
        $title: getNavigationBarTitle(route),
        $url_path: route,
        ...data,
      });
    }
  },
};
